import React from 'react';
import PropTypes from 'prop-types';
import { m, AnimatePresence } from 'framer-motion';
import { styled } from '@linaria/react';
import SubMenuItem from 'components-v3/Sidebar/SubMenuItem.jsx';
import { SubMenuWrapper } from './styles.js';
import { secondaryTransitionConfig } from 'constants/animationConfig.js';

const SubMenuList = styled(m.ul)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  margin: 0 5px 0 0;
  list-style-type: none;
`;

const list = {
  visible: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.3,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      when: 'afterChildren',
    },
  },
};

const SubMenu = ({
  submenu = [],
  disabled,
  isShown,
  align = 'top',
}) => {
  return (
    <SubMenuWrapper align={align}>
      <AnimatePresence>
        {isShown && (
          <SubMenuList
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={list}
            transition={secondaryTransitionConfig}
          >
            {submenu.map((subMenuItem) => (
              <SubMenuItem
                key={subMenuItem.title}
                disabled={disabled}
                subMenuItem={subMenuItem}
                flair={subMenuItem.flair}
              />
            ))}
          </SubMenuList>
        )}
      </AnimatePresence>
    </SubMenuWrapper>
  );
};

SubMenu.propTypes = {
  selectedNavigationItem: PropTypes.object,
};

export default SubMenu;
